import script from "./assign-work-report.vue?vue&type=script&setup=true&lang=js"
export * from "./assign-work-report.vue?vue&type=script&setup=true&lang=js"

import "./assign-work-report.vue?vue&type=style&index=0&id=ada843c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ada843c2"]])

export default __exports__